"use strict";

(() => {
  /* waves, by gnykka (codepen.io/gnykka/pen/RwdgGJj, MIT): the homepage art,
     redrawn in shades of beige for the closed screen. 50 rows of
     drifting ridges, 24fps, paused off screen, hidden tabs and reduced motion. */
  const canvas = document.getElementById('krhuNest');
  if (!canvas || canvas.dataset.wavesReady) return;
  canvas.dataset.wavesReady = 'true';
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const rows = Array.from({ length: 50 }, () => ({
    samples: Array.from({ length: 80 }, () => Math.round(Math.random() * 100)),
    color: `hsl(${30 + Math.random() * 12} ${22 + Math.random() * 20}% ${60 + Math.random() * 30}%)`
  }));
  function density(samples) {
    return Array.from({ length: 76 }, (_, i) => {
      const x = i * 100 / 75;
      return samples.reduce((sum, v) => {
        const n = (x - v) / 3;
        return sum + (Math.abs(n) <= 1 ? .25 * (1 - n * n) : 0);
      }, 0) / samples.length;
    });
  }
  let width = 0, height = 0, frame = 0, last = 0, visible = true;
  rows.forEach(row => { row.levels = density(row.samples); });
  function draw() {
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = '#f4eedd';
    ctx.fillRect(0, 0, width, height);
    rows.forEach((row, i) => {
      const base = (i + 1) * (height + 28) / rows.length;
      const points = row.levels.map((v, j) => [j * width / 75, base - v * height * 5]);
      ctx.beginPath();
      ctx.moveTo(points[0][0], points[0][1]);
      for (let j = 1; j < points.length - 1; j++) {
        ctx.quadraticCurveTo(points[j][0], points[j][1], (points[j][0] + points[j + 1][0]) / 2, (points[j][1] + points[j + 1][1]) / 2);
      }
      ctx.lineTo(points[points.length - 1][0], points[points.length - 1][1]);
      ctx.lineTo(width, height + 30);
      ctx.lineTo(0, height + 30);
      ctx.closePath();
      ctx.fillStyle = row.color;
      ctx.fill();
      ctx.strokeStyle = '#6b5a45';
      ctx.lineWidth = .4;
      ctx.stroke();
    });
  }
  function tick(now) {
    frame = 0;
    if (!canvas.isConnected) { resize.disconnect(); observer.disconnect(); return; }
    if (now - last >= 1000 / 24) {
      rows.forEach(row => {
        row.samples.shift();
        row.samples.push(Math.round(Math.random() * 100));
        row.levels = density(row.samples);
      });
      draw();
      last = now;
    }
    schedule();
  }
  function schedule() {
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    if (visible && !document.hidden && !reduced.matches) frame = requestAnimationFrame(tick);
  }
  const resize = new ResizeObserver(() => {
    width = canvas.clientWidth;
    height = canvas.clientHeight;
    const ratio = Math.min(devicePixelRatio || 1, 2);
    canvas.width = Math.round(width * ratio);
    canvas.height = Math.round(height * ratio);
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    draw();
  });
  resize.observe(canvas);
  const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
  observer.observe(canvas);
  document.addEventListener('visibilitychange', schedule);
  reduced.addEventListener('change', schedule);
})();

(() => {
  const tabs = [...document.querySelectorAll('.signup-modes button')];
  function select(index) {
    tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      document.getElementById(tab.getAttribute('aria-controls')).hidden = i !== index;
    });
    document.querySelector('.mx-legal').hidden = tabs[index].id !== 'sms-tab';
    document.getElementById('email-returning').hidden = tabs[index].id !== 'email-tab';
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(index));
    tab.addEventListener('keydown', event => {
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - index;
        select(next); tabs[next].focus();
      }
    });
  });
  const song = document.getElementById('mxAuxSong');
  function formatSong() {
    if (song.querySelector('.aux-artist')) return;
    const text = song.textContent, split = text.indexOf(' - ');
    if (split < 0) return;
    song.textContent = text.slice(0, split);
    const artist = document.createElement('span'); artist.className = 'aux-artist';
    artist.textContent = text.slice(split + 3); song.append(artist);
  }
  // team aux can be left off the page; skip the formatter when it is
  if (song) {
    new MutationObserver(formatSong).observe(song, { childList: true });
    formatSong();
  }
})();
